import { render, staticRenderFns } from "./OrderProductList.vue?vue&type=template&id=1281fa70&scoped=true&"
import script from "./OrderProductList.vue?vue&type=script&lang=js&"
export * from "./OrderProductList.vue?vue&type=script&lang=js&"
import style0 from "./OrderProductList.vue?vue&type=style&index=0&id=1281fa70&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1281fa70",
  null
  
)

export default component.exports